import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Site-wide sale banner + hook to read discount pct anywhere */
let cached = null;
let subscribers = new Set();

const notify = () => subscribers.forEach((cb) => cb(cached));

export const usePromo = () => {
  const [promo, setPromo] = useState(cached);
  useEffect(() => {
    if (cached) return;
    subscribers.add(setPromo);
    api
      .get("/promo")
      .then((r) => {
        cached = r.data;
        notify();
      })
      .catch(() => {});
    return () => subscribers.delete(setPromo);
  }, []);
  return promo;
};

/** Compute discounted price string from a comma-formatted INR string. */
export const applyDiscount = (priceStr, pct) => {
  const raw = Number(String(priceStr).replace(/,/g, "")) || 0;
  const disc = raw - (raw * pct) / 100;
  return {
    original: raw,
    discounted: disc,
    formattedOriginal: raw.toLocaleString("en-IN"),
    formattedDiscounted: Math.round(disc).toLocaleString("en-IN"),
  };
};

export const PromoBanner = () => {
  const promo = usePromo();
  if (!promo?.active) return null;
  const isBogo = promo.type === "bogo";
  return (
    <div
      data-testid="promo-banner"
      className="relative z-[55] border-b border-[#D4AF37]/40 bg-gradient-to-r from-[#0A0807] via-[#221913] to-[#0A0807]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-3 md:py-4 flex items-center justify-center gap-3 md:gap-5 text-center flex-wrap">
        <span className="text-[11px] md:text-xs tracking-overline uppercase font-bold text-[#D4AF37]">
          ✦ {promo.label} ✦
        </span>
        <span
          data-testid="promo-banner-headline"
          className="font-serif-display text-xl md:text-3xl leading-none text-[#F4EAD9]"
        >
          {isBogo ? (
            <>
              <b className="text-[#D4AF37] font-normal italic">Buy 1 Get 1 Free</b> on every perfume
            </>
          ) : (
            <>
              Flat <b className="text-[#D4AF37] font-normal italic">{promo.discount_pct}% OFF</b> everything
            </>
          )}
        </span>
        <span className="hidden sm:inline text-[11px] tracking-wide text-[#B0A496]">
          · auto-applied at checkout
        </span>
      </div>
    </div>
  );
};

export default PromoBanner;
